
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SettingsArtworkLinkSelectorV1Field } from "../settings-artwork-link-selector-v1.class";
import { SettingsCustomFormFieldData } from '../../../../models/settings/settings-custom-form-field-data.class';

import { FormsFieldItemMenuClick } from '../../../settings-field-menu/field-menu-item.model';
import { FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp, FieldsMenuReallyRemove } from '../../../settings-field-menu/fields.menu';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

import * as Objects from '@core/objects';
import { KeySelectItem } from '@core/models/select-item.model';
import { InterfaceListenerService } from '@core/services/interface-listener/interface-listener.service';
import { CoreCustomFormsFiltersService } from '@core/services/custom-forms/custom-forms.service';
import * as CformsSearch from '@core/custom-forms/models/field-search.model';


@Component({
    selector: 'form-field-settings-artwork-link-selector-v1',
    templateUrl: './settings-artwork-link-selector-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsArtworkLinkSelectorV1FieldComponent implements OnInit, OnChanges {
    private readonly MENU_REMOVE_WITH_CONFIRM = "confirmation-remove";
    private readonly MENU_REALLY_REMOVE = "really-remove";
    private readonly MENU_DISMISS_REMOVE = "dismiss-really-remove";

    @Input() field: SettingsArtworkLinkSelectorV1Field;
    @Input() dependencies: SettingsCustomFormFieldData[]; // could be 2 different classes
    @Output() fieldChange = new EventEmitter<SettingsArtworkLinkSelectorV1Field>();
    @Output() menuClick = new EventEmitter<FormsFieldItemMenuClick>();

    public placeholder: string = "Name of the Artwork Link field";
    public form: FormGroup = new FormGroup({});
    public items: Array<KeySelectItem> = [];
    public removingDynamic: number = -1;
    public removingStatus: boolean = false;
    public open: boolean = false;
    public itemMouseDown: boolean = false;
    public filtersOpen: boolean = false;
    public tagsOpen: boolean = false;
    private wasInside: boolean = false;
    public selectedFilter: string = ''; // to mark what filter is displayed
    public menuAddFilter: ThreeDotsMenuItem =  {
        title: "Add a filter",
        key: "add-filter",
        icon: "add",
        order: 1
    };

    public fieldMenu: Array<ThreeDotsMenuItem> = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp, this.menuAddFilter];


    public filtersMenu: Array<CformsSearch.SearchFilterMenuItem> = [
        {
            title: 'Tag Filter',
            key: 'label',
            order: 2
        },{
            title: 'Status Filter',
            key: 'status',
            order: 3
        }
    ];

    public availableStatus: CformsSearch.SearchAvailableFilters = null;
    public availableLabels: CformsSearch.SearchAvailableFilters = null;
    public dependenciesItems: Array<KeySelectItem>

    private subs: Subscription[] = [];

    constructor(
        private filtersSrv: CoreCustomFormsFiltersService,
        private iListenerSrv: InterfaceListenerService,
        private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.subs.push(
            this.filtersSrv.selectInitializedFilters().subscribe((initialized: boolean) => {
                if(!initialized)
                    this.filtersSrv.loadFilters();
            })
        );
        // this.updateMenuItems();
        this.subs.push(
            this.filtersSrv.selectLabels().subscribe((filter: CformsSearch.SearchAvailableFilters) => {
                this.availableLabels = filter;
                this.cdr.markForCheck();
            })
        );

        this.subs.push(
            this.filtersSrv.selectStatus().subscribe((filter: CformsSearch.SearchAvailableFilters) => {
                this.availableStatus = filter
                this.cdr.markForCheck();
            })
        );

        this.subs.push(
            this.iListenerSrv.getDocuementClicked$().subscribe((value: any ) => {
                // this listen all clicks in the document, so we need to check what was ours
                if(this.open && !this.wasInside){
                    this.open = false;
                    this.filtersOpen = false;
                    this.selectedFilter = '';
                    if(this.fieldMenu.some((mi:ThreeDotsMenuItem) => mi.key === this.MENU_REALLY_REMOVE))
                        this.onMenuClick(this.MENU_DISMISS_REMOVE);
                    this.cdr.markForCheck();
                } else {
                    this.wasInside = false;
                }
            })
        );

        this.init();
    }
    

    // maybe not needed at all
    ngOnChanges(changes: SimpleChanges): void {

        if(changes.field){
            // this.updateMenuItems();
            this.cdr.markForCheck();
        }
        if(changes.dependencies){
            
            // console.log(" ## AW link ngOnChanges dependencies=>",changes.dependencies);
        }
    }
    
    ngOnDestroy(): void {
        this.subs.forEach((sub: Subscription) => sub.unsubscribe());
    }

    protected init(){
        this.dependenciesItems = this.dependencies
            .map((fi: SettingsCustomFormFieldData) => ({
                selected: false,
                key: fi.id.toString(),
                description: fi.label,
                disabled: false
            }));

        // control to remove dynamic when some fields are updated.
        const deletedIndex = this.field.dynamic_field.findIndex(dynamicFieldId =>
            !this.dependencies.some(dependency => dependency.id === dynamicFieldId)
        );
        
        if (deletedIndex !== -1) {
            this.reallyRemoveDynamic(deletedIndex);
        }
        this.cdr.markForCheck();
    }

    // Update creating new objects to ensure change detection    
    onMandatoryChange(mandatory: boolean) {
        // Create a new object to ensure change detection
        this.field = this.field.update({ mandatory: mandatory});
        this.emit(this.field);
    }

    onFieldChange(labelText: string) {
        this.emit(this.field.update({ label: labelText}));;
    }

    // attempt with confirmation
    removeStatus() {
        this.removingStatus = true;
    }

    // the real action  to remove option from the list
    reallyRemoveStatus() {
        this.emit(this.field.update({ status_filter: null}));
        this.removingStatus = false;
    }

    // attempt with confirmation
    removeTag(tag: Objects.Label) {
        this.emit(this.field.update({ tag_filter: this.field.tag_filter.filter((tfid: number) => tfid !== tag.id)}));
    }

    // attempt with confirmation
    removeDynamic(index: number, field?: SettingsArtworkLinkSelectorV1Field) {
        this.removingDynamic = index;
    }

    // the real action  to remove dynamic fillter from the list
    reallyRemoveDynamic(index: number, field?: SettingsArtworkLinkSelectorV1Field) {
        this.emit(this.field.update({ dynamic_field: this.field.dynamic_field.filter((_ : string, i) => i !== index)}));
        this.cdr.markForCheck();
        this.removingDynamic = -1;
    }

    dynamicIsReally( index: number) : boolean {
        return  index === this.removingDynamic;
    }

    onMenuClick(key: string) {
        switch(key) {
            case "add-filter":
                this.toggleMenuFilters();
                break;
            // see ThreeDotsMenuItem interface definition to see how works this confirmation remove
            case this.MENU_REMOVE_WITH_CONFIRM: //"confirmation-remove":
                this.fieldMenu = [this.menuAddFilter, FieldsMenuMoveDown,  FieldsMenuMoveUp, FieldsMenuReallyRemove];
                break;
            case this.MENU_DISMISS_REMOVE: // "dismiss-really-remove": // pseudo key to return to basic menu
                this.fieldMenu = [...FieldsStandardRemoveMenuItem, this.menuAddFilter, FieldsMenuMoveDown,  FieldsMenuMoveUp];
                break;
            default:
                const itemClicked: FormsFieldItemMenuClick = {key: key, field: this.field}
                this.menuClick.emit(itemClicked);
        }
        
    }

    startClick(key: string, event: any) {
        if(key === this.MENU_REMOVE_WITH_CONFIRM)
            this.itemMouseDown = true;
        event.stopPropagation();
    }

    endClick(key: string, event: any) {
        if(key === this.MENU_REMOVE_WITH_CONFIRM){
            this.itemMouseDown = false;
            this.onMenuClick(key);
        }
        event.stopPropagation();
        
    }

    onSelectFilter(key: string){
        this.selectedFilter = key;
        this.wasInside = true;
    }

    toggleMenu(){
        this.open = !this.open;
        this.wasInside = true;
    }

    toggleMenuFilters(){
        this.filtersOpen = !this.filtersOpen;
        this.wasInside = true;
    }
    toggleLabels(){
        this.tagsOpen = !this.tagsOpen;
        this.wasInside = true;
    }

    onFilterApply(filter: CformsSearch.SearchAppliedFilter) : void {
        switch (filter.key) {
            case 'label':
                this.tagFilterSelect(filter.identifier)
                break;
            case 'status':
                this.statusFilterSelect(filter.identifier)
                break;
            default:
                break;
        }
    }

    onDynamicFilterAdd() : void {
        this.selectedFilter = '';
        this.emit(this.field.update({ dynamic_field: [...this.field.dynamic_field, '']}));
        this.wasInside = false;
    }


    updateDynamicField(index: number, selected: KeySelectItem) : void {
        // Update the dynamic field at the specified index
        const selectedField = this.dependencies.find((fi: SettingsCustomFormFieldData) => fi.id === selected.key);
        if (selectedField) {
            // Create a new array with updated field associated
            const updatedDynamicFields = [...this.field.dynamic_field];
            updatedDynamicFields[index] = selectedField.id;
            this.emit(this.field.update({ dynamic_field: updatedDynamicFields }));
        }
    }

    getTag(id: number) {
        return this.availableLabels?.items.find(l => l.id === id)
    }

    getStatus(id: number) {
        return this.availableStatus?.items.find(s => s.id === id)
    }

    private tagFilterSelect(tag_id: number){
        this.selectedFilter = '';
        this.emit(this.field.update({ tag_filter: [...this.field.tag_filter, tag_id]}));
        this.wasInside = false;
    }

    private statusFilterSelect(status_id: number){

        this.selectedFilter = '';
        this.emit(this.field.update({ status_filter: status_id}));
        this.wasInside = false;
    }

    private emit(updatedField:SettingsArtworkLinkSelectorV1Field): void {

        this.fieldChange.emit(updatedField);
    }

    // this track function should prevent loops on options when display the content.
    protected trackByFn(index: number, option: string): any {
        return index; // some unique identifier
    }

    // private updateMenuItems(){
    //     this.fieldMenu = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp ];
    //     // if(this.field.position == 1 ){
    //     //     this.fieldMenu = (this.total == 1) ? [...FieldsStandardRemoveMenuItem] : [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown]
    //     // } else {
    //     //     this.fieldMenu =  (this.field.position == this.total
    //     //         ? [...FieldsStandardRemoveMenuItem, FieldsMenuMoveUp]
    //     //         : [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp ]);
    //     // }
    // }

}
